module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d15ff2adc7daddbb8569643785cdf7a1.png";